export const getLocalImageUrl = (src: string) =>
  `${
    process.env.NEXT_PUBLIC_VERCEL_URL
      ? process.env.NEXT_PUBLIC_VERCEL_URL.startsWith('http')
        ? process.env.NEXT_PUBLIC_VERCEL_URL
        : `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
      : ''
  }${src[0] === '/' ? src : `/${src}`}`;
